// extracted by mini-css-extract-plugin
export default {"scroll":"Sidebar_scroll__LzvY-"};